import type {
  ArdoqId,
  GlobalComponentTypeUsageResponse,
} from '@ardoq/api-types';

export type LocalComponentTypeStyling = {
  color: string;
  icon: string | null;
  shape: string | null;
  image: string | null;
  standard: string | null;
};

export type LocalComponentTypeAttributes = {
  _id: ArdoqId;
  level: number;
  description: string | null;
  styling: LocalComponentTypeStyling;
};

export type LocalComponentTypeEdits = LocalComponentTypeStyling & {
  description: string;
};

export const ENTITY_USAGE_SECTIONS = [
  'broadcasts',
  'reports',
  'scenarios',
  'surveys',
  'presentations',
  'viewpoints',
  'perspectives',
  'fields',
  'jobs',
  'tabularMappings',
] as const;

export type EntityUsageSection = (typeof ENTITY_USAGE_SECTIONS)[number];

export type UsageSection = 'workspaces' | EntityUsageSection;

export type EntityUsage = {
  [Section in EntityUsageSection]: GlobalComponentTypeUsageResponse[Section]['entities'];
};

export type DetailsSection = 'overview' | UsageSection;
